import pluralize from "pluralize";

export const handleNumberInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (e.key === "e" || e.key === "E" || e.key === "+" || e.key === "-") {
    e.preventDefault();
  }
};

export const roundToNearestCent = (value: number): number => {
  return Math.round(value * 100) / 100;
};

export const formatShiftsText = (shifts: number): string => {
  return `${shifts} ${pluralize("shift", shifts)}`;
};
